import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { InfinitySpin } from "react-loader-spinner";
import { Typography } from "@mui/material";
function Mentorship() {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teaching, setTeaching] = useState();
  const location = useLocation();
  const urlArr = location.pathname.split("/");
  const url = urlArr[urlArr.length - 1];
  console.log(url);
  const regex = /(https?:\/\/.*\.(?:png|jpg|jpeg))/i;
  useEffect(() => {
    window.scrollTo(0, 200);
    async function netlifyFunc() {
      const mentorship = await fetch(
        "https://dratunroychoudhury.netlify.app/.netlify/functions/publication-function",
        {
          method: "post",
          headers: { "Content-Type": "Application/json" },
          body: JSON.stringify({ url: "research_guidance" }),
        }
      );
      const mentorshipData = await mentorship.json();
      setTeaching(mentorshipData);
      console.log("research-guid ", mentorshipData);
      const res = await fetch(
        "https://dratunroychoudhury.netlify.app/.netlify/functions/publication-function",
        {
          method: "post",
          headers: { "Content-Type": "Application/json" },
          body: JSON.stringify({ url: url }),
        }
      );
      const data = await res.json();
      console.log("data ", data);
      // data.sort((a, b) => a.Year - b.Year);
      data.sort((a, b) => a["No."] - b["No."]);
      setTableData(data);
      setLoading(false);
    }
    netlifyFunc();
  }, [url]);
  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        {loading ? (
          <InfinitySpin
            visible={true}
            height="196"
            width="196"
            color="green"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        ) : (
          <>
            <Box>
              <Typography variant="h4" marginTop={"2%"}>
                Research Guidance
              </Typography>
              <table>
                <tr>
                  {Object.keys(teaching[0]).map((heading) => (
                    <th>{heading}</th>
                  ))}
                </tr>
                {teaching.map((row) => (
                  <tr>
                    {Object.keys(row).map((col) => {
                      return String(row[col]).match(regex) !== null ? (
                        <td>
                          <img
                            src={row[col]}
                            alt={row[col]}
                            style={{
                              height: "151px",
                              width: "150px",
                              // borderRadius: "50%",
                              // border: "2px solid black",
                            }}
                          />
                        </td>
                      ) : (
                        <td>{row[col]}</td>
                      );
                    })}
                  </tr>
                ))}
              </table>
            </Box>
            <Box>
              <Typography variant="h4" marginTop={"6%"}>
                Teaching & Mentorship
              </Typography>
              <table>
                <tr>
                  {Object.keys(tableData[0]).map((heading) => (
                    <th>{heading}</th>
                  ))}
                </tr>
                {tableData.map((row) => (
                  <tr>
                    {Object.keys(row).map((col) => {
                      return String(row[col]).match(regex) !== null ? (
                        <td>
                          <img
                            src={row[col]}
                            alt={row[col]}
                            style={{
                              height: "151px",
                              width: "150px",
                              // borderRadius: "50%",
                              // border: "2px solid black",
                            }}
                          />
                        </td>
                      ) : (
                        <td>{row[col]}</td>
                      );
                    })}
                  </tr>
                ))}
              </table>
            </Box>
          </>
        )}
      </Box>
    </>
  );
}

export default Mentorship;
